<template>
  <span class="irrigationStateWidget">
    <template v-if="value.toLowerCase() == 'on'">
      <span title="Irrigation valve open">
        <v-icon
          v-if="!disabled"
          :size="iconSize"
          color="blue"
          >water_drop</v-icon
        >
        <v-icon
          v-else
          :size="iconSize"
          color="rgb(192, 192, 192)"
        >water_drop</v-icon
        >
      </span>
    </template>
    <template v-if="value.toLowerCase() == 'waiting'">
      <span title="Irrigation Waiting to acquire lease">
        <v-icon
          v-if="!disabled"
          :size="iconSize"
          color="teal"
          >water_drop</v-icon
        >
        <v-icon
          v-else
          :size="iconSize"
          color="rgb(192, 192, 192)"
        >water_drop</v-icon
        >
      </span>
    </template>
    <template v-else-if="value.toLowerCase() == 'off'">
      <span title="Irrigation Closed">
        <v-icon v-if="!disabled" :size="iconSize"
          >water_drop</v-icon
        >
        <v-icon v-else :size="iconSize" color="rgb(192, 192, 192)"
        >water_drop</v-icon
        >
      </span>
    </template>
    <template v-else-if="value.toLowerCase() == 'updating'">
      <img src="/img/Spinner-1s-30px.gif" />
    </template>
  </span>
</template>

<script>
export default {
  name: "",
  props: ["value", "iconSize", "disabled"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
